import React, { FC, useContext } from "react"
import { useFormikContext } from "formik"

import SaveButton from "@/components/buttons/SaveButton"
import { SubmittingContext } from "@/onboarding/features/product/helpers"

const SubmitButton: FC = () => {
  const { dirty, isValid } = useFormikContext()
  const [submitting] = useContext(SubmittingContext)

  return <SaveButton type="submit" disabled={!dirty || submitting || !isValid} />
}

export default SubmitButton
